import './modal-badge.scss';
import ModalTemplate from '../modal-template/modal-template';
import Button from '../button/button';
import { ASSETS } from '../../constants';
import UtilsService from '../../services/utils-service';

export default function ModalBadge(props) {

    const getDescription = () => {
        const hitos = {
            'PREGUNTAS_CONTESTADAS': "Alcanza {hito} preguntas respondidas",
            'PREGUNTAS_CORRECTAS': "Alcanza {hito} preguntas respondidas correctamente",
            'RETOS_PERSONALES_JUGADOS': "Acumula {hito} retos personales jugados",
            'RETOS_PERSONALES_GANADOS': "Acumula {hito} retos personales ganados",
            'PUNTOS_ACUMULADOS': "Acumula {hito} puntos",
            'COMPETENCIAS_EQUIPO_GANADAS': "Gana {hito} competencias en equipo",
        }

        let description = hitos[props.badge.tipo];

        switch (props.badge.tipo) {
            case 'PREGUNTAS_CONTESTADAS':
                return description.replace('{hito}', props.badge.preguntasContestadas);

            case 'PREGUNTAS_CORRECTAS':
                return description.replace('{hito}', props.badge.preguntasCorrectas);

            case 'RETOS_PERSONALES_JUGADOS':
                return description.replace('{hito}', props.badge.retosPersonalesJugados);

            case 'RETOS_PERSONALES_GANADOS':
                return description.replace('{hito}', props.badge.totalGanados);

            case 'PUNTOS_ACUMULADOS':
                return description.replace('{hito}', props.badge.puntosAcumulados);

            case 'COMPETENCIAS_EQUIPO_GANADAS':
                return description.replace('{hito}', props.badge.competenciasEquipoGanadas);
            
            default:
                return 'Sin descripción';

        }
    }

    return (
        <ModalTemplate isOpen={props.isOpen} className='modal-badge' >
            {props.badge &&
                <>
                    <div className='badge-icon mx-auto  my-[41px]' style={{ backgroundImage: `url("${ASSETS.ICONS_ACHIEVEMENTS}${props.badge.icono}")` }}></div>
                    <div className='text-center'>
                        <h1 className='heading-h3 mb-[16px]'>{props.badge.nombre}</h1>
                        <p className='mb-[24px]'>{ getDescription() }</p>
                        {props.badge.conseguida && <p className='text-secundary '>Got: {UtilsService.formatDate(props.badge.fecha)}</p>}


                        <Button className='mt-[24px]' onClick={props.onClose}>
                            Got it!
                        </Button>
                    </div>
                </>
            }

        </ModalTemplate>
    )
}